// Author : Vishnu
//Version :0.0.1
// MODIFIED DATE: 18/08/2025
import { all, call, put, takeLatest } from 'redux-saga/effects';
import ChangeMeetingDateActionTypes from './change-meeting-date.type';
import {
	getBranchMeetingDateDetailsFailure,
	getBranchMeetingDateDetailsResponseChanged,
	getBranchMeetingDateDetailsSuccess,
	getLoanCenterGroupDetailsFailure,
	getLoanCenterGroupDetailsResponseChanged,
	getLoanCenterGroupDetailsSuccess,
	getParticularLoanCenterGroupDetailsFailure,
	getParticularLoanCenterGroupDetailsResponseChanged,
	getParticularLoanCenterGroupDetailsSuccess,
	updateBranchMeetingDateFailure,
	updateBranchMeetingDateResponseChanged,
	updateBranchMeetingDateSuccess,
	updateSingleBranchMeetingDateFailure,
	updateSingleBranchMeetingDateResponseChanged,
	updateSingleBranchMeetingDateSuccess,
	updateSingleCenterMeetingDateFailure,
	updateSingleCenterMeetingDateResponseChanged,
	updateSingleCenterMeetingDateSuccess,
	updateSingleMemberMeetingDateFailure,
	updateSingleMemberMeetingDateResponseChanged,
	updateSingleMemberMeetingDateSuccess,
	getBranchMeetingDateDetailsAutoLoanFailure,
	getBranchMeetingDateDetailsAutoLoanResponseChanged,
	getBranchMeetingDateDetailsAutoLoanSuccess,
	getLoanCenterGroupDetailsAutoLoanFailure,
	getLoanCenterGroupDetailsAutoLoanResponseChanged,
	getLoanCenterGroupDetailsAutoLoanSuccess,
	getParticularLoanCenterGroupDetailsAutoLoanFailure,
	getParticularLoanCenterGroupDetailsAutoLoanResponseChanged,
	getParticularLoanCenterGroupDetailsAutoLoanSuccess,
	updateBranchMeetingDateAutoLoanFailure,
	updateBranchMeetingDateAutoLoanResponseChanged,
	updateBranchMeetingDateAutoLoanSuccess,
	updateSingleBranchMeetingDateAutoLoanFailure,
	updateSingleBranchMeetingDateAutoLoanResponseChanged,
	updateSingleBranchMeetingDateAutoLoanSuccess,
	updateSingleCenterMeetingDateAutoLoanFailure,
	updateSingleCenterMeetingDateAutoLoanResponseChanged,
	updateSingleCenterMeetingDateAutoLoanSuccess,
	updateSingleMemberMeetingDateAutoLoanFailure,
	updateSingleMemberMeetingDateAutoLoanResponseChanged,
	updateSingleMemberMeetingDateAutoLoanSuccess,
} from './change-meeting-date.action';
import { encryptData } from '../../_common/enode-decode';
import AlertManager from '../../../utils/alertManager';
import {
	ChangeBranchMeetingDateGet,
	ChangeBranchMeetingDateUpdate,
	ChangeSingleBranchMeetingDateUpdate,
	ChangeSingleCenterMeetingDateUpdate,
	ChangeSingleMemberMeetingDateUpdate,
	FetchLoanCenterGroupDetails,
	FetchLoanDetailsBasedOnCenterGroup,
	ChangeBranchMeetingDateGetAutoLoan,
	ChangeBranchMeetingDateUpdateAutoLoan,
	ChangeSingleBranchMeetingDateUpdateAutoLoan,
	ChangeSingleCenterMeetingDateUpdateAutoLoan,
	ChangeSingleMemberMeetingDateUpdateAutoLoan,
	FetchLoanCenterGroupDetailsAutoLoan,
	FetchLoanDetailsBasedOnCenterGroupAutoLoan,
} from './change-meeting-date.service';

/***************   Start Update Branch Meeting Date ******************/
export function* updateChangeBranchMeetingDateDetails({ payload }: any) {
	try {
		const key = 'UpdateBranchCentersMeetingDateKey';
		const { branchID, meetingDate, changeMeetingDate, databaseName, companyID } = payload;
		const jsonData = {
			BranchID: branchID,
			MeetingDate: meetingDate,
			ChangeDate: changeMeetingDate,
			DatabaseName: databaseName,
			CompanyID: companyID,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(ChangeBranchMeetingDateUpdate, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(updateBranchMeetingDateFailure(responseData.data));
		} else {
			yield put(updateBranchMeetingDateSuccess(responseData.data));
		}
	} catch (error) {
		yield put(updateBranchMeetingDateFailure(error));
	}
}

export function* resetUpdateChangeBranchMeetingDateResponse() {
	yield put(updateBranchMeetingDateResponseChanged());
}

export function* onUpdateBranchMeetingDateDetails() {
	yield takeLatest(
		ChangeMeetingDateActionTypes.UPDATE_BRANCH_MEETING_DATE_START,
		updateChangeBranchMeetingDateDetails,
	);
}

export function* onUpdateBranchMeetingDateDetailsResponseReset() {
	yield takeLatest(
		ChangeMeetingDateActionTypes.UPDATE_BRANCH_MEETING_DATE_RESPONSE_RESET,
		resetUpdateChangeBranchMeetingDateResponse,
	);
}

export function* updateChangeBranchMeetingDateDetailsAutoLoan({ payload }: any) {
	try {
		const key = 'UpdateBranchCentersMeetingDateAutoLoanKey';
		const { branchID, meetingDate, changeMeetingDate, databaseName, companyID } = payload;
		const jsonData = {
			BranchID: branchID,
			MeetingDate: meetingDate,
			ChangeDate: changeMeetingDate,
			DatabaseName: databaseName,
			CompanyID: companyID,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(ChangeBranchMeetingDateUpdateAutoLoan, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(updateBranchMeetingDateAutoLoanFailure(responseData.data));
		} else {
			yield put(updateBranchMeetingDateAutoLoanSuccess(responseData.data));
		}
	} catch (error) {
		yield put(updateBranchMeetingDateAutoLoanFailure(error));
	}
}

export function* resetUpdateChangeBranchMeetingDateResponseAutoLoan() {
	yield put(updateBranchMeetingDateAutoLoanResponseChanged());
}

export function* onUpdateBranchMeetingDateDetailsAutoLoan() {
	yield takeLatest(
		ChangeMeetingDateActionTypes.UPDATE_BRANCH_MEETING_DATE_AUTO_LOAN_START,
		updateChangeBranchMeetingDateDetailsAutoLoan,
	);
}

export function* onUpdateBranchMeetingDateDetailsResponseResetAutoLoan() {
	yield takeLatest(
		ChangeMeetingDateActionTypes.UPDATE_BRANCH_MEETING_DATE_AUTO_LOAN_RESPONSE_RESET,
		resetUpdateChangeBranchMeetingDateResponseAutoLoan,
	);
}
/***************   End Update Branch Meeting Date ******************/

/***************   Get Branch Meeting Date Details Start ******************/
export function* getChangeBranchMeetingDateDetails({ payload }: any) {
	try {
		const key = 'FetchBranchMeetingDateDetailsKey';
		const { branchID, meetingDate, changeMeetingDate, databaseName, companyID } = payload;
		const jsonData = {
			BranchID: branchID,
			MeetingDate: meetingDate,
			ChangeDate: changeMeetingDate,
			DatabaseName: databaseName,
			CompanyID: companyID,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(ChangeBranchMeetingDateGet, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(getBranchMeetingDateDetailsFailure(responseData.data));
		} else {
			yield put(getBranchMeetingDateDetailsSuccess(responseData.data));
		}
	} catch (error) {
		yield put(getBranchMeetingDateDetailsFailure(error));
	}
}

export function* resetGetChangeBranchMeetingDateResponse() {
	yield put(getBranchMeetingDateDetailsResponseChanged());
}

export function* onGetBranchMeetingDateDetails() {
	yield takeLatest(
		ChangeMeetingDateActionTypes.GET_BRANCH_MEETING_DATE_DETAILS_START,
		getChangeBranchMeetingDateDetails,
	);
}

export function* onGetBranchMeetingDateDetailsResponseReset() {
	yield takeLatest(
		ChangeMeetingDateActionTypes.GET_BRANCH_MEETING_DATE_DETAILS_RESPONSE_RESET,
		resetGetChangeBranchMeetingDateResponse,
	);
}

export function* getChangeBranchMeetingDateDetailsAutoLoan({ payload }: any) {
	try {
		const key = 'FetchBranchMeetingDateDetailsAutoLoanKey';
		const { branchID, meetingDate, changeMeetingDate, databaseName, companyID } = payload;
		const jsonData = {
			BranchID: branchID,
			MeetingDate: meetingDate,
			ChangeDate: changeMeetingDate,
			DatabaseName: databaseName,
			CompanyID: companyID,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(ChangeBranchMeetingDateGetAutoLoan, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(getBranchMeetingDateDetailsAutoLoanFailure(responseData.data));
		} else {
			yield put(getBranchMeetingDateDetailsAutoLoanSuccess(responseData.data));
		}
	} catch (error) {
		yield put(getBranchMeetingDateDetailsAutoLoanFailure(error));
	}
}

export function* resetGetChangeBranchMeetingDateResponseAutoLoan() {
	yield put(getBranchMeetingDateDetailsAutoLoanResponseChanged());
}

export function* onGetBranchMeetingDateDetailsAutoLoan() {
	yield takeLatest(
		ChangeMeetingDateActionTypes.GET_BRANCH_MEETING_DATE_DETAILS_AUTO_LOAN_START,
		getChangeBranchMeetingDateDetailsAutoLoan,
	);
}

export function* onGetBranchMeetingDateDetailsResponseResetAutoLoan() {
	yield takeLatest(
		ChangeMeetingDateActionTypes.GET_BRANCH_MEETING_DATE_DETAILS_AUTO_LOAN_RESPONSE_RESET,
		resetGetChangeBranchMeetingDateResponseAutoLoan,
	);
}
/***************   Get Branch Meeting Date Details End ******************/

/***************  Get Loan Center Group Details Start ******************/
export function* getLoanCenterGroupDetails({ payload }: any) {
	try {
		const key = 'LoanCenterGroupDetailsListKey';
		const { centerID, groupBy, databaseName, companyID } = payload;
		const jsonData = {
			CenterID: centerID,
			ChangeType: groupBy,
			DatabaseName: databaseName,
			CompanyID: companyID,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(FetchLoanCenterGroupDetails, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(getLoanCenterGroupDetailsFailure(responseData.data));
		} else {
			yield put(getLoanCenterGroupDetailsSuccess(responseData.data));
		}
	} catch (error) {
		yield put(getLoanCenterGroupDetailsFailure(error));
	}
}

export function* resetGetLoanCenterGroupResponse() {
	yield put(getLoanCenterGroupDetailsResponseChanged());
}

export function* onGetLoanCenterGroupDetails() {
	yield takeLatest(
		ChangeMeetingDateActionTypes.GET_LOAN_CENTER_GROUP_DETAILS_START,
		getLoanCenterGroupDetails,
	);
}

export function* onGetLoanCenterGroupDetailsResponseReset() {
	yield takeLatest(
		ChangeMeetingDateActionTypes.GET_LOAN_CENTER_GROUP_DETAILS_RESPONSE_RESET,
		resetGetLoanCenterGroupResponse,
	);
}

export function* getLoanCenterGroupDetailsAutoLoan({ payload }: any) {
	try {
		const key = 'LoanCenterGroupDetailsListAutoLoanKey';
		const { centerID, groupBy, databaseName, companyID } = payload;
		const jsonData = {
			CenterID: centerID,
			ChangeType: groupBy,
			DatabaseName: databaseName,
			CompanyID: companyID,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(FetchLoanCenterGroupDetailsAutoLoan, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(getLoanCenterGroupDetailsAutoLoanFailure(responseData.data));
		} else {
			yield put(getLoanCenterGroupDetailsAutoLoanSuccess(responseData.data));
		}
	} catch (error) {
		yield put(getLoanCenterGroupDetailsAutoLoanFailure(error));
	}
}

export function* resetGetLoanCenterGroupResponseAutoLoan() {
	yield put(getLoanCenterGroupDetailsAutoLoanResponseChanged());
}

export function* onGetLoanCenterGroupDetailsAutoLoan() {
	yield takeLatest(
		ChangeMeetingDateActionTypes.GET_LOAN_CENTER_GROUP_DETAILS_AUTO_LOAN_START,
		getLoanCenterGroupDetailsAutoLoan,
	);
}

export function* onGetLoanCenterGroupDetailsResponseResetAutoLoan() {
	yield takeLatest(
		ChangeMeetingDateActionTypes.GET_LOAN_CENTER_GROUP_DETAILS_AUTO_LOAN_RESPONSE_RESET,
		resetGetLoanCenterGroupResponseAutoLoan,
	);
}
/***************  Get Loan Center Group Details End ******************/

/***************  Get Loan Index Details Based On Center Group Start ******************/
export function* getParticularLoanCenterGroupDetails({ payload }: any) {
	try {
		const key = 'FetchLoanDetailsBasedOnCenterGroupKey';
		const { groupID, loanIndexID, changeType, centerID, databaseName, companyID } = payload;
		const jsonData = {
			GroupID: groupID,
			LoanIndexID: loanIndexID,
			ChangeType: changeType,
			CenterID: centerID,
			DatabaseName: databaseName,
			CompanyID: companyID,
		};
		const encodeData = encryptData(jsonData, key);
		//@ts-ignore
		const responseData = yield call(FetchLoanDetailsBasedOnCenterGroup, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(getParticularLoanCenterGroupDetailsFailure(responseData.data));
		} else {
			yield put(getParticularLoanCenterGroupDetailsSuccess(responseData.data));
		}
	} catch (error) {
		yield put(getParticularLoanCenterGroupDetailsFailure(error));
	}
}

export function* resetGetParticularLoanCenterGroupResponse() {
	yield put(getParticularLoanCenterGroupDetailsResponseChanged());
}

export function* onGetParticularLoanCenterGroupDetails() {
	yield takeLatest(
		ChangeMeetingDateActionTypes.GET_PARTICULAR_LOAN_CENTER_GROUP_DETAILS_START,
		getParticularLoanCenterGroupDetails,
	);
}

export function* onGetParticularLoanCenterGroupDetailsResponseReset() {
	yield takeLatest(
		ChangeMeetingDateActionTypes.GET_PARTICULAR_LOAN_CENTER_GROUP_DETAILS_RESPONSE_RESET,
		resetGetParticularLoanCenterGroupResponse,
	);
}

export function* getParticularLoanCenterGroupDetailsAutoLoan({ payload }: any) {
	try {
		const key = 'FetchLoanDetailsBasedOnCenterGroupAutoLoanKey';
		const { groupID, loanIndexID, changeType, centerID, databaseName, companyID } = payload;
		const jsonData = {
			GroupID: groupID,
			LoanIndexID: loanIndexID,
			ChangeType: changeType,
			CenterID: centerID,
			DatabaseName: databaseName,
			CompanyID: companyID,
		};
		const encodeData = encryptData(jsonData, key);
		//@ts-ignore
		const responseData = yield call(FetchLoanDetailsBasedOnCenterGroupAutoLoan, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(getParticularLoanCenterGroupDetailsAutoLoanFailure(responseData.data));
		} else {
			yield put(getParticularLoanCenterGroupDetailsAutoLoanSuccess(responseData.data));
		}
	} catch (error) {
		yield put(getParticularLoanCenterGroupDetailsAutoLoanFailure(error));
	}
}

export function* resetGetParticularLoanCenterGroupResponseAutoLoan() {
	yield put(getParticularLoanCenterGroupDetailsAutoLoanResponseChanged());
}

export function* onGetParticularLoanCenterGroupDetailsAutoLoan() {
	yield takeLatest(
		ChangeMeetingDateActionTypes.GET_PARTICULAR_LOAN_CENTER_GROUP_DETAILS_AUTO_LOAN_START,
		getParticularLoanCenterGroupDetailsAutoLoan,
	);
}

export function* onGetParticularLoanCenterGroupDetailsResponseResetAutoLoan() {
	yield takeLatest(
		ChangeMeetingDateActionTypes.GET_PARTICULAR_LOAN_CENTER_GROUP_DETAILS_AUTO_LOAN_RESPONSE_RESET,
		resetGetParticularLoanCenterGroupResponseAutoLoan,
	);
}
/***************  Get Loan Index Details Based On Center Group End ******************/

/***************   Start Update Branch New Meeting Date ******************/
export function* updateSingleBranchMeetingDateDetails({ payload }: any) {
	try {
		const key = 'UpdateBranchMeetingDateKey';
		const {
			branchID,
			meetingDate,
			changeDate,
			databaseName,
			companyID,
			branchChangeType,
			whichWeek,
			whichDay,
			userID,
			branchChangeReason,
			changeMeetingCenterArr,
			isSameDueDateBranch,
		} = payload;
		const jsonData = {
			BranchID: branchID,
			MeetingDate: meetingDate,
			ChangeDate: changeDate,
			DatabaseName: databaseName,
			CompanyID: companyID,
			BranchChangeType: branchChangeType,
			WhichWeek: whichWeek,
			WhichDay: whichDay,
			UserID: userID,
			BranchChangeReason: branchChangeReason,
			ChangeMeetingCenterArr: changeMeetingCenterArr,
			IsSameDueDateBranch: isSameDueDateBranch,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(ChangeSingleBranchMeetingDateUpdate, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(updateSingleBranchMeetingDateFailure(responseData.data));
		} else {
			yield put(updateSingleBranchMeetingDateSuccess(responseData.data));
		}
	} catch (error) {
		yield put(updateSingleBranchMeetingDateFailure(error));
	}
}

export function* resetUpdateSingleBranchMeetingDateResponse() {
	yield put(updateSingleBranchMeetingDateResponseChanged());
}

export function* onUpdateSingleBranchMeetingDateDetails() {
	yield takeLatest(
		ChangeMeetingDateActionTypes.UPDATE_SINGLE_BRANCH_MEETING_DATE_START,
		updateSingleBranchMeetingDateDetails,
	);
}

export function* onUpdateSingleBranchMeetingDateDetailsResponseReset() {
	yield takeLatest(
		ChangeMeetingDateActionTypes.UPDATE_SINGLE_BRANCH_MEETING_DATE_RESPONSE_RESET,
		resetUpdateSingleBranchMeetingDateResponse,
	);
}

export function* updateSingleBranchMeetingDateDetailsAutoLoan({ payload }: any) {
	try {
		const key = 'UpdateBranchMeetingDateAutoLoanKey';
		const {
			branchID,
			meetingDate,
			changeDate,
			databaseName,
			companyID,
			branchChangeType,
			whichWeek,
			whichDay,
			userID,
			branchChangeReason,
			changeMeetingCenterArr,
			isSameDueDateBranch,
		} = payload;
		const jsonData = {
			BranchID: branchID,
			MeetingDate: meetingDate,
			ChangeDate: changeDate,
			DatabaseName: databaseName,
			CompanyID: companyID,
			BranchChangeType: branchChangeType,
			WhichWeek: whichWeek,
			WhichDay: whichDay,
			UserID: userID,
			BranchChangeReason: branchChangeReason,
			ChangeMeetingCenterArr: changeMeetingCenterArr,
			IsSameDueDateBranch: isSameDueDateBranch,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(ChangeSingleBranchMeetingDateUpdateAutoLoan, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(updateSingleBranchMeetingDateAutoLoanFailure(responseData.data));
		} else {
			yield put(updateSingleBranchMeetingDateAutoLoanSuccess(responseData.data));
		}
	} catch (error) {
		yield put(updateSingleBranchMeetingDateAutoLoanFailure(error));
	}
}

export function* resetUpdateSingleBranchMeetingDateResponseAutoLoan() {
	yield put(updateSingleBranchMeetingDateAutoLoanResponseChanged());
}

export function* onUpdateSingleBranchMeetingDateDetailsAutoLoan() {
	yield takeLatest(
		ChangeMeetingDateActionTypes.UPDATE_SINGLE_BRANCH_MEETING_DATE_AUTO_LOAN_START,
		updateSingleBranchMeetingDateDetailsAutoLoan,
	);
}

export function* onUpdateSingleBranchMeetingDateDetailsResponseResetAutoLoan() {
	yield takeLatest(
		ChangeMeetingDateActionTypes.UPDATE_SINGLE_BRANCH_MEETING_DATE_AUTO_LOAN_RESPONSE_RESET,
		resetUpdateSingleBranchMeetingDateResponseAutoLoan,
	);
}
/***************   End Update Branch New Meeting Date ******************/

/***************  Update Loan Index Meeting Date Time Start ******************/
export function* updateSingleCenterMeetingDateDetails({ payload }: any) {
	try {
		const key = 'UpdateMeetingDateAndTimeForLoanIndexKey';
		const {
			GroupID,
			GroupOfficerID,
			companyID,
			databaseName,
			LoanIndexID,
			PreviousMeetingTime,
			previousMeetingDate,
			centerID,
			branchID,
			changeType,
			changeCenterGroup,
			changeDate,
			meetingTime,
			changeReason,
			changedBy,
			whichWeek,
			whichDay,
			isSameDueDate,
		} = payload;
		const jsonData = {
			CompanyID: companyID,
			DatabaseName: databaseName,
			CenterID: centerID,
			BranchID: branchID,
			ChangeType: changeType,
			ChangeCenterGroup: changeCenterGroup,
			ChangeDate: changeDate,
			MeetingTime: meetingTime,
			ChangeReason: changeReason,
			ChangedBy: changedBy,
			WhichWeek: whichWeek,
			WhichDay: whichDay,
			IsSameDueDate: isSameDueDate,
			PreviousMeetingDate: previousMeetingDate,
			PreviousMeetingTime: PreviousMeetingTime,
			LoanIndexID: LoanIndexID,
			GroupID: GroupID,
			GroupOfficerID: GroupOfficerID,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(ChangeSingleCenterMeetingDateUpdate, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(updateSingleCenterMeetingDateFailure(responseData.data));
		} else {
			yield put(updateSingleCenterMeetingDateSuccess(responseData.data));
		}
	} catch (error) {
		yield put(updateSingleCenterMeetingDateFailure(error));
	}
}

export function* resetUpdateSingleCenterMeetingDateResponse() {
	yield put(updateSingleCenterMeetingDateResponseChanged());
}

export function* onUpdateSingleCenterMeetingDateDetails() {
	yield takeLatest(
		ChangeMeetingDateActionTypes.UPDATE_SINGLE_CENTER_MEETING_DATE_START,
		updateSingleCenterMeetingDateDetails,
	);
}

export function* onUpdateSingleCenterhMeetingDateDetailsResponseReset() {
	yield takeLatest(
		ChangeMeetingDateActionTypes.UPDATE_SINGLE_CENTER_MEETING_DATE_RESPONSE_RESET,
		resetUpdateSingleCenterMeetingDateResponse,
	);
}

export function* updateSingleCenterMeetingDateDetailsAutoLoan({ payload }: any) {
	try {
		const key = 'UpdateMeetingDateAndTimeForLoanIndexAutoLoanKey';
		const {
			GroupID,
			GroupOfficerID,
			companyID,
			databaseName,
			LoanIndexID,
			PreviousMeetingTime,
			previousMeetingDate,
			centerID,
			branchID,
			changeType,
			changeCenterGroup,
			changeDate,
			meetingTime,
			changeReason,
			changedBy,
			whichWeek,
			whichDay,
			isSameDueDate,
		} = payload;
		const jsonData = {
			CompanyID: companyID,
			DatabaseName: databaseName,
			CenterID: centerID,
			BranchID: branchID,
			ChangeType: changeType,
			ChangeCenterGroup: changeCenterGroup,
			ChangeDate: changeDate,
			MeetingTime: meetingTime,
			ChangeReason: changeReason,
			ChangedBy: changedBy,
			WhichWeek: whichWeek,
			WhichDay: whichDay,
			IsSameDueDate: isSameDueDate,
			PreviousMeetingDate: previousMeetingDate,
			PreviousMeetingTime: PreviousMeetingTime,
			LoanIndexID: LoanIndexID,
			GroupID: GroupID,
			GroupOfficerID: GroupOfficerID,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(ChangeSingleCenterMeetingDateUpdateAutoLoan, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(updateSingleCenterMeetingDateAutoLoanFailure(responseData.data));
		} else {
			yield put(updateSingleCenterMeetingDateAutoLoanSuccess(responseData.data));
		}
	} catch (error) {
		yield put(updateSingleCenterMeetingDateAutoLoanFailure(error));
	}
}

export function* resetUpdateSingleCenterMeetingDateResponseAutoLoan() {
	yield put(updateSingleCenterMeetingDateAutoLoanResponseChanged());
}

export function* onUpdateSingleCenterMeetingDateDetailsAutoLoan() {
	yield takeLatest(
		ChangeMeetingDateActionTypes.UPDATE_SINGLE_CENTER_MEETING_DATE_AUTO_LOAN_START,
		updateSingleCenterMeetingDateDetailsAutoLoan,
	);
}

export function* onUpdateSingleCenterhMeetingDateDetailsResponseResetAutoLoan() {
	yield takeLatest(
		ChangeMeetingDateActionTypes.UPDATE_SINGLE_CENTER_MEETING_DATE_AUTO_LOAN_RESPONSE_RESET,
		resetUpdateSingleCenterMeetingDateResponseAutoLoan,
	);
}
/***************  Update Loan Index Meeting Date Time End ******************/

/***************  Update Loan Index Meeting Date Time Member Wise Start ******************/
export function* updateSingleMemberMeetingDateDetails({ payload }: any) {
	try {
		const key = 'UpdateMeetingDateTimeForLoanIndexMemberwiseKey';
		const {
			GroupID,
			GroupOfficerID,
			companyID,
			databaseName,
			LoanIndexID,
			PreviousMeetingTime,
			centerID,
			branchID,
			changeType,
			changeCenterGroup,
			changeDate,
			meetingTime,
			changeReason,
			changedBy,
			whichWeek,
			whichDay,
			isSameDueDate,
			previousMeetingDate,
			loanIndexGroupMemberID,
		} = payload;
		const jsonData = {
			GroupID: GroupID,
			GroupOfficerID: GroupOfficerID,
			LoanIndexID: LoanIndexID,
			CompanyID: companyID,
			DatabaseName: databaseName,
			PreviousMeetingTime: PreviousMeetingTime,
			CenterID: centerID,
			BranchID: branchID,
			ChangeType: changeType,
			ChangeCenterGroup: changeCenterGroup,
			ChangeDate: changeDate,
			MeetingTime: meetingTime,
			ChangeReason: changeReason,
			ChangedBy: changedBy,
			WhichWeek: whichWeek,
			WhichDay: whichDay,
			IsSameDueDate: isSameDueDate,
			PreviousMeetingDate: previousMeetingDate,
			LoanIndexGroupMemberID: loanIndexGroupMemberID,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(ChangeSingleMemberMeetingDateUpdate, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(updateSingleMemberMeetingDateFailure(responseData.data));
		} else {
			yield put(updateSingleMemberMeetingDateSuccess(responseData.data));
		}
	} catch (error) {
		yield put(updateSingleMemberMeetingDateFailure(error));
	}
}

export function* resetUpdateSingleMemberMeetingDateResponse() {
	yield put(updateSingleMemberMeetingDateResponseChanged());
}

export function* onUpdateSingleMemberMeetingDateDetails() {
	yield takeLatest(
		ChangeMeetingDateActionTypes.UPDATE_SINGLE_MEMBER_MEETING_DATE_START,
		updateSingleMemberMeetingDateDetails,
	);
}

export function* onUpdateSingleMemberhMeetingDateDetailsResponseReset() {
	yield takeLatest(
		ChangeMeetingDateActionTypes.UPDATE_SINGLE_MEMBER_MEETING_DATE_RESPONSE_RESET,
		resetUpdateSingleMemberMeetingDateResponse,
	);
}

export function* updateSingleMemberMeetingDateDetailsAutoLoan({ payload }: any) {
	try {
		const key = 'UpdateMeetingDateTimeForLoanIndexMemberwiseAutoLoanKey';
		const {
			GroupID,
			GroupOfficerID,
			companyID,
			databaseName,
			LoanIndexID,
			PreviousMeetingTime,
			centerID,
			branchID,
			changeType,
			changeCenterGroup,
			changeDate,
			meetingTime,
			changeReason,
			changedBy,
			whichWeek,
			whichDay,
			isSameDueDate,
			previousMeetingDate,
			loanIndexGroupMemberID,
		} = payload;
		const jsonData = {
			GroupID: GroupID,
			GroupOfficerID: GroupOfficerID,
			LoanIndexID: LoanIndexID,
			CompanyID: companyID,
			DatabaseName: databaseName,
			PreviousMeetingTime: PreviousMeetingTime,
			CenterID: centerID,
			BranchID: branchID,
			ChangeType: changeType,
			ChangeCenterGroup: changeCenterGroup,
			ChangeDate: changeDate,
			MeetingTime: meetingTime,
			ChangeReason: changeReason,
			ChangedBy: changedBy,
			WhichWeek: whichWeek,
			WhichDay: whichDay,
			IsSameDueDate: isSameDueDate,
			PreviousMeetingDate: previousMeetingDate,
			LoanIndexGroupMemberID: loanIndexGroupMemberID,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(ChangeSingleMemberMeetingDateUpdateAutoLoan, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(updateSingleMemberMeetingDateAutoLoanFailure(responseData.data));
		} else {
			yield put(updateSingleMemberMeetingDateAutoLoanSuccess(responseData.data));
		}
	} catch (error) {
		yield put(updateSingleMemberMeetingDateAutoLoanFailure(error));
	}
}

export function* resetUpdateSingleMemberMeetingDateResponseAutoLoan() {
	yield put(updateSingleMemberMeetingDateAutoLoanResponseChanged());
}

export function* onUpdateSingleMemberMeetingDateDetailsAutoLoan() {
	yield takeLatest(
		ChangeMeetingDateActionTypes.UPDATE_SINGLE_MEMBER_MEETING_DATE_AUTO_LOAN_START,
		updateSingleMemberMeetingDateDetailsAutoLoan,
	);
}

export function* onUpdateSingleMemberhMeetingDateDetailsResponseResetAutoLoan() {
	yield takeLatest(
		ChangeMeetingDateActionTypes.UPDATE_SINGLE_MEMBER_MEETING_DATE_AUTO_LOAN_RESPONSE_RESET,
		resetUpdateSingleMemberMeetingDateResponseAutoLoan,
	);
}
/***************  Update Loan Index Meeting Date Time Member Wise End ******************/

export function* changeMeetingDateSaga() {
	yield all([
		call(onUpdateBranchMeetingDateDetails),
		call(onUpdateBranchMeetingDateDetailsResponseReset),
		call(onUpdateBranchMeetingDateDetailsAutoLoan),
		call(onUpdateBranchMeetingDateDetailsResponseResetAutoLoan),
		call(onGetBranchMeetingDateDetails),
		call(onGetBranchMeetingDateDetailsResponseReset),
		call(onGetBranchMeetingDateDetailsAutoLoan),
		call(onGetBranchMeetingDateDetailsResponseResetAutoLoan),
		call(onGetLoanCenterGroupDetails),
		call(onGetLoanCenterGroupDetailsResponseReset),
		call(onGetLoanCenterGroupDetailsAutoLoan),
		call(onGetLoanCenterGroupDetailsResponseResetAutoLoan),
		call(onGetParticularLoanCenterGroupDetails),
		call(onGetParticularLoanCenterGroupDetailsResponseReset),
		call(onGetParticularLoanCenterGroupDetailsAutoLoan),
		call(onGetParticularLoanCenterGroupDetailsResponseResetAutoLoan),
		call(onUpdateSingleBranchMeetingDateDetails),
		call(onUpdateSingleBranchMeetingDateDetailsResponseReset),
		call(onUpdateSingleBranchMeetingDateDetailsAutoLoan),
		call(onUpdateSingleBranchMeetingDateDetailsResponseResetAutoLoan),
		call(onUpdateSingleCenterMeetingDateDetails),
		call(onUpdateSingleCenterhMeetingDateDetailsResponseReset),
		call(onUpdateSingleCenterMeetingDateDetailsAutoLoan),
		call(onUpdateSingleCenterhMeetingDateDetailsResponseResetAutoLoan),
		call(onUpdateSingleMemberMeetingDateDetails),
		call(onUpdateSingleMemberhMeetingDateDetailsResponseReset),
		call(onUpdateSingleMemberMeetingDateDetailsAutoLoan),
		call(onUpdateSingleMemberhMeetingDateDetailsResponseResetAutoLoan),
	]);
}
